import Chocolat from "chocolat";

const lightboxParentEls = document.querySelectorAll("[data-js-chocolat]");
lightboxParentEls.forEach((lightboxParentEl) => {
  const lightboxItemEls = lightboxParentEl.querySelectorAll(".chocolat-image");
  const imageSetTitleEl = lightboxParentEl.querySelector("[data-js-chocolat-title]");
  Chocolat(lightboxItemEls, {
    allowZoom: true,
    loop: true,
    setTitle: () => (imageSetTitleEl ? imageSetTitleEl.innerText : null),
  });
});
